<mat-checkbox [formControl]="control" [color]="color" [labelPosition]="labelPosition">
    <ng-content></ng-content>
</mat-checkbox>